<template>
  <div>
 
    <!-- STATUS BADGE -->
    <div class="bg-white rounded border-0 shadow-sm my-3">
      <div class="d-flex align-items-end py-3 pl-3 pr-3">
        <div class="d-flex flex-column">
          <h5 class="mb-1">Basic Status Badge</h5>
          <p class="text-gray-500">Basic badges. Use the <span class="text-danger">variant</span> prop to change the color.</p>
        </div>
 
        <ButtonGroup>
          <b-button :class="{'active' : view === 'preview'}" @click="view = 'preview'">Preview</b-button>
          <b-button :class="{'active' : view === 'code'}"  @click="view = 'code'">Code</b-button>
        </ButtonGroup>
      </div>
 
      <CodePreviewViewer :viewMode="view" :codeSample="require('@/components/local/StatusBadge/status.js').default">
        <template v-slot:preview>
          <div class="w-100">
            <StatusBadge class="m-2" variant="success">Verified</StatusBadge>
            <StatusBadge class="m-2" variant="warning">Pending</StatusBadge>
            <StatusBadge class="m-2" variant="danger">Overdue</StatusBadge>
            <StatusBadge class="m-2" variant="primary">Completed</StatusBadge>
            <StatusBadge class="m-2" variant="secondary">On Hold</StatusBadge>
          </div>
        </template>
      </CodePreviewViewer>    
    </div>
 
  </div>
</template>
 
<script>
import StatusBadge from '@/components/export/StatusBadge/StatusBadge'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'
 
export default {
  components: { StatusBadge, ButtonGroup, CodePreviewViewer },
 
  data () {
    return {
      view: 'preview'
    }
  }
}
</script>